import React from 'react';
import styled from 'styled-components';
import ActionsContextV2, { ActionsStore } from './ActionsContextV2';
import ActionsFormV2 from './actionsFormV2/ActionsFormV2';
import CenteredLoadingIndicator from '../common/CenteredLoadingIndicator';
import EmptyStateMessage from '../common/EmptyStateMessage';
import ActionsProjectSelection from './actionsFormV2/ActionsProjectSelection';
import ActionsReadOnlyEmptyState from './ActionsReadOnlyEmptyState';
import ActionsNoAccessEmptyState from './ActionsNoAccessEmptyState';
import _ from 'lodash';


const Content = styled.div`
  
`;


const renderContent = (context) => {

    if (context.actionsRedux.fetchingProjectFunctions || context.actionsRedux.submittingActions ) {
                        
        return <CenteredLoadingIndicator/> 

    }else if (context.actionsRedux.projectFunctions && context.actionsRedux.projectFunctions.length === 0) {
        return <ActionsNoAccessEmptyState/>
                

    }else if (context.actionsRedux.projectFunctions && context.actionsRedux.projectFunctionsMine.length === 0 && !context.actionsRedux.selectedProject) {
        return <ActionsReadOnlyEmptyState context={context}/>             

    }else  {
     return <Content>

                    <ActionsProjectSelection/>
                    {context.actionsRedux.fetchingProjectFunctionDetails ?
                        <CenteredLoadingIndicator/> 
                        :
                        <ActionsFormV2 initialValues={{selectedProjectFunctionDetails:context.actionsRedux.selectedProjectFunctionDetails}}/>
                    }


                
        </Content> 
    }
}

const ActionsMainV2 = (props) => {

    return (
        <ActionsStore>
        <ActionsContextV2.Consumer>
        {context => renderContent(context)}
        </ActionsContextV2.Consumer>
                   
        
        </ActionsStore>
    )
}

export default ActionsMainV2;